// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9VfXt","location":"Header_location__3dXQd"};